import { ComponentFactory } from "@angular/core";

export interface PrintInjectData {
  component: ComponentFactory<any>;
  params: PrintParamsData;
}

export interface PrintParamsData {
  [key: string]: any;
}

export interface PrintConfig {
  async?: boolean;
  debug_mode?: boolean;
}
